import {
  createUserPreferences,
  updateUserPreferences,
  updateUserProfile
} from 'api/services/UserService';
import { loadUserProfile, loadUserSettings } from 'api/services/UserServiceTS';
import { useState } from 'react';
import { toast } from 'react-toastify';

interface UserPreferences {
  notifications?: {
    [x: string]: boolean;
  };
}
export const UserPreferencesModel = () => {
  // not used  ? const user = useContext(UserContext);
  const [preferences, setPreferences] = useState<UserPreferences>();
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined);
  const getPreferences = () => {
    loadUserSettings(
      res => {
        // TODO : if user doesnt have preferences them we make an api call to create them

        // otherwhise we show his preferences
        setPreferences(res.data);
      },
      (error: any) => {
        createUserPreferences(
          {
            notifications: {
              covalo_digest_enabled: true
            }
          },
          (res: any) => setPreferences(res.data),
          (error: any) => toast.error(error.message)
        );
        toast(error.message);
      }
    );
  };

  function updateObject(object: any, newValue: any, path: any) {
    const stack = path.split('.');

    while (stack.length > 1) {
      object = object[stack.shift()];
    }

    object[stack.shift()] = newValue;
  }

  const updatePreferences = (preference: any, newValue: boolean) => {
    const data = preferences;
    updateObject(data, newValue, preference);

    if (data) {
      updateUserPreferences(
        data,
        () => toast.success('Preference updated'),
        (error: any) => toast(error.message)
      );
      setPreferences({ ...data });
    }
  };
  //temporary until backend change
  const getPhoneNumber = () => {
    loadUserProfile(res => {
      const { phone_number } = res.data;
      setPhoneNumber(phone_number);
    });
  };
  const onNewsLetterChangeHandler = (newValue: boolean) => {
    loadUserProfile(res => {
      const { shipping_address } = res.data;
      //TODO: why does backend returns us this value when they reject updating with it ???
      shipping_address?.country && delete shipping_address?.country;
      updateUserProfile(
        { ...res.data, shipping_address, newsletter: newValue },
        () => {},
        () => {
          toast.error('something went wrong');
        }
      );
    });
  };

  return {
    getPreferences,
    preferences,
    updatePreferences,
    onNewsLetterChangeHandler,
    getPhoneNumber,
    phoneNumber
  };
};
